<template>
    <div v-if="errors.length > 0"></div>
    <div class="card shadow mb-2">
        <div class="card-body">
            <div class="col-2">
                <label for="yearselector">{{ $trans.get("__JSON__.Year") }}</label>
                <select id="yearselector" v-model="selectedYear" class="form-select">
                    <option v-for="year in years" :key="year">
                        {{ year }}
                    </option>
                </select>
            </div>
        </div>
    </div>

    <div class="card shadow">
        <div class="card-body">
            <table class="table table-striped">
                <thead>
                    <tr>
                    <th></th>
                    <th v-for="client in clients" :key="client.id">
                        {{ client.name }}
                    </th>
                    </tr>   
                </thead>
                <tbody>
                    <tr v-for="week in 52" :key="week" class="text-end">
                        <td>{{ week }}</td>
                        <td v-for="client in clients" :key="client.id"><span @click="changeBudget(client, week)"
                                v-if="(client.id + '-' + week) != hidespan">
                                {{ getClientBudget(client.id, week) }}
                            </span>
                            <input class="number-input" type="number" :id="client.id + '-' + week"
                                v-model="selectedBudget.fulltimeequivalent"
                                v-if="selectedClient && selectedClient.id == client.id && selectedWeek == week && edit == true"
                                step=".01" @keyup.enter="saveBudget" @keyup.esc="cancelBudget" @blur="cancelBudget"
                                v-focus>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>

    <div class="modal" tabindex="-1" id="budgetmodal">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">
                        {{ $trans.get("__JSON__.Change budget") }}
                    </h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    <div class="mb-3">
                        <label for="clientname">{{
        $trans.get("__JSON__.Client")
    }}</label>
                        <input v-if="selectedClient" id="clientname" type="text" class="form-control"
                            v-model="selectedClient.name" disabled />
                    </div>
                    <div class="mb-3">
                        <label for="year">{{
        $trans.get("__JSON__.Year")
    }}</label>
                        <input id="year" type="text" class="form-control" v-model="selectedYear" disabled />
                    </div>
                    <div class="mb-3">
                        <label for="week">{{
        $trans.get("__JSON__.From week")
    }}</label>
                        <input id="week" type="text" class="form-control" v-model="selectedWeek" disabled />
                    </div>
                    <div class="mb-3">
                        <label for="fulltimeequivalent">{{
        $trans.get("__JSON__.FTE")
    }}</label>
                        <input v-if="selectedBudget" id="fulltimeequivalent" type="number" class="form-control"
                            v-model="selectedBudget.fulltimeequivalent" />
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
                        {{ $trans.get("__JSON__.Close") }}
                    </button>
                    <button type="button" class="btn btn-primary" @click="saveBudget">
                        {{ $trans.get("__JSON__.Save") }}
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { ref, watch } from "vue";

import getClients from "../composables/getClients";
import getClientBudgets from "../composables/getClientBudgets";

export default {
    name: "ClientBudgets",
    props: {
        year: String,
        startyear: String,
    },
    setup(props) {
        const { clients, clients_error, loadClients } = getClients();
        loadClients();

        const { clientbudgets, clientbudgets_error, loadClientBudgets } =
            getClientBudgets();
        loadClientBudgets();

        return { clients, clientbudgets, loadClientBudgets };
    },
    methods: {
        getClientBudget(clientId, week) {
            if (this.clientbudgets) {
                var budget = this.findBudget(clientId, week);
                if (budget) {
                    return budget.fulltimeequivalent;
                }
            }
            return 0, 0;
        },
        findBudget(clientId, week) {
            var budget = this.clientbudgets.find(
                (item) =>
                    item.client_id == clientId &&
                    item.year == this.selectedYear &&
                    item.week == week
            );
            if (budget) {
                return budget;
            } else {
                var budget = this.clientbudgets.filter(
                    (item) =>
                        item.client_id == clientId &&
                        item.year == this.selectedYear &&
                        item.week < week
                );
                if (budget.length > 0) {
                    const maxweek = Math.max(...budget.map((o) => o.week));
                    if (maxweek > 0) {
                        budget = this.clientbudgets.find(
                            (item) =>
                                item.client_id == clientId &&
                                item.year == this.selectedYear &&
                                item.week == maxweek
                        );
                        return budget;
                    }
                }
            }
            return null;
        },
        changeBudget(client, week) {
            this.selectedClient = client;
            this.selectedWeek = week;

            this.selectedBudget = this.findBudget(client.id, week);

            if (!this.selectedBudget) {
                this.selectedBudget = {
                    id: null,
                    client_id: client.id,
                    year: this.selectedYear,
                    week: week,
                    fulltimeequivalent: 0,
                };
            }

            if (this.selectedBudget.week != week) {
                this.selectedBudget = { ...this.selectedBudget }
                this.selectedBudget.id = null;
                this.selectedBudget.week = week;
            }

            // $("#budgetmodal").modal("show");
            this.oldfte = this.selectedBudget.fulltimeequivalent;
            this.hidespan = client.id + '-' + week;
            this.edit = true;
        },
        saveBudget() {
            if (this.selectedBudget.id > 0) {
                axios
                    .put(
                        "/api/clientbudgets/" + this.selectedBudget.id,
                        this.selectedBudget
                    )
                    .then((resp) => {
                        self.errors = [];
                        this.hidespan = '';
                        this.edit = false;
                        this.loadClientBudgets();
                    })
                    .catch((error) => {
                        self.errors = error.response.data.errors;
                    });
            } else {
                axios
                    .post("/api/clientbudgets", this.selectedBudget)
                    .then((resp) => {
                        this.selectedBudget.id = resp.data.id;
                        self.errors = [];
                        this.loadClientBudgets();
                        this.hidespan = '';
                        this.edit = false;
                        this.loadClientBudgets();

                    })
                    .catch((error) => {
                        self.errors = error.response.data.errors;
                    });
            }
        },
        cancelBudget() {
            this.selectedBudget.fulltimeequivalent = this.oldfte;
            this.hidespan = '';
            this.edit = false;
        }
    },
    created() {
        this.startYearInt = parseInt(this.startyear);
        this.yearInt = parseInt(this.year);
        this.selectedYear = this.yearInt;

        this.years = [];
        for (var year = this.startYearInt; year < this.yearInt + 2; year++) {
            this.years.push(year);
        }
    },
    watch: {
        projselectedYear: {
            handler(newValue, oldValue) {
                if (oldValue != null) {
                    this.loadClientBudgets();
                }
            }
        },
    },
    data() {
        return {
            startYearInt: null,
            yearInt: null,
            selectedYear: null,
            years: null,
            selectedClient: null,
            selectedWeek: null,
            selectedBudget: null,
            errors: [],
            edit: false,
            hidespan: '',
            oldfte: 0
        };
    },
};
</script>

<style lang="scss" scoped>
th {
    writing-mode: vertical-rl;
    //    transform-origin: 0 0;
       transform: rotate(180deg);
}

.number-input {
    min-width: 10px !important;
    max-width: 3rem !important;
    width: 100% !important;
    box-sizing: border-box !important;
    -webkit-box-sizing: border-box !important;
    -moz-box-sizing: border-box !important;
    padding: 0 !important;
    margin: 0 !important;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
}

/* Firefox */
input[type=number] {
    -moz-appearance: textfield;
}
</style>
